import { AuditDetails, Entity } from '../entity';
import { Lex } from '../shared/lexorank';
import { PagingOptions } from '../shared/paging.options';
import { SaleOrder, SaleOrderStatus } from './sale.order';
import { SaleOrderViewFilters } from './sale.order.view.filter';

export enum SaleOrderViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum SaleOrderViewDisplayType {
    Kanban = 'Kanban',
    Grid = 'Grid'
}

export type SaleOrderViewSortType = 'ASC' | 'DESC';

export enum SaleOrderViewSortBy {
    None = 'none',
    Name = 'name',
    CreatedAt = 'createdAt',
    Date = 'date',
    ExpiryDate = 'expiryDate',
}

export interface SaleOrderViewSortOptions {
    sortBy: SaleOrderViewSortBy;
    sortType: SaleOrderViewSortType;
}

export interface SaleOrderViewSummary {
    _id: string;
    name: string;
    visibility: SaleOrderViewVisibility;
    displayType: SaleOrderViewDisplayType;
    sort?: SaleOrderViewSortOptions;
    card: SaleOrderViewCardFields,
    list: SaleOrderViewListField[];
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: SaleOrderViewFilters;
}

export interface SaleOrderViewCardFields {
    number: boolean;
    customerRef: boolean;
    account: boolean;
    billingCompany: boolean;

    date: boolean;
    expiryDate: boolean;
    createdAt: boolean;
}

export interface SaleOrderView extends Entity, AuditDetails {
    displayType?: SaleOrderViewDisplayType;
    visibility?: SaleOrderViewVisibility;
    sharedWith?: Entity[];

    system?: boolean;

    filters: SaleOrderViewFilters;
    card: SaleOrderViewCardFields;
    list: SaleOrderViewListField[];

    canEditView?: boolean;
    canShareView?: boolean;

    sort?: SaleOrderViewSortOptions;
}

export const DefaultSaleOrderViewCards: SaleOrderViewCardFields = {
    number: true,
    customerRef: true,
    account: true,
    billingCompany: true,
    date: true,
    expiryDate: true,
    createdAt: true,
};

export const emptySaleOrderView = (data?: Partial<SaleOrderView>): SaleOrderView => {
    return {
        name: null,
        description: null,
        displayType: SaleOrderViewDisplayType.Kanban,
        visibility: SaleOrderViewVisibility.Private,
        sharedWith: [],
        filters: {},
        card: { ...DefaultSaleOrderViewCards },
        list: [...DefaultSaleOrderFields],
        ...data,
    } as SaleOrderView;
}


export interface SaleOrderViewSortOptions {
    sortBy: SaleOrderViewSortBy;
    sortType: SaleOrderViewSortType;
}

export interface SaleOrderViewRequest {
    sort: SaleOrderViewSortOptions;
    view: SaleOrderViewSummary;
    filters: SaleOrderViewFilters;
    paging: PagingOptions
}

export interface SaleOrderViewResponse {
    views: SaleOrderViewSummary[];
    columns: SaleOrderStatus[];
    pageTotal: number;
    total: number;
    items: SaleOrder[];
    paging: PagingOptions
}

export interface SaleOrderViewListField {
    _id: keyof SaleOrder;
    name: string;
    visible: boolean;
    sortOrder?: Lex;
    system: boolean;
}

export const DefaultSaleOrderFields: SaleOrderViewListField[] = [
    { _id: 'saleOrderNumber', name: 'Sale Order Number', visible: true, system: true },
    { _id: 'status', name: 'Status', visible: true, system: true },

    { _id: 'customerRef', name: 'Customer Reference', visible: true, system: true },
    { _id: 'account', name: 'Account', visible: true, system: true },
    { _id: 'billingCompany', name: 'Company', visible: true, system: true },

    { _id: 'date', name: 'Date', visible: true, system: true },
    { _id: 'expiryDate', name: 'Expiry Date', visible: true, system: true },
    { _id: 'createdAt', name: 'Created Date', visible: true, system: true },
    { _id: 'totalEx', name: 'Total Excl. Tax', visible: true, system: true },
    { _id: 'totalInc', name: 'Total Inc. Tax', visible: true, system: true },
];